var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import className from 'classnames';
import { When, BackgroundImage } from '@alife/simple-ui';
import { getMultiLangText } from '../../../utils/text';
var FollowCard = (function (_super) {
    __extends(FollowCard, _super);
    function FollowCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FollowCard.prototype.render = function () {
        var _a = this.props, _b = _a.locale, locale = _b === void 0 ? {} : _b, onClick = _a.onClick, templateData = _a.templateData, _c = _a.langKey, langKey = _c === void 0 ? "en" : _c;
        var title = templateData.title, desc = templateData.desc, iconUrl = templateData.iconUrl, mallIconUrl = templateData.mallIconUrl;
        var titleStr = locale.followCardTitle ? locale.followCardTitle : getMultiLangText(title, langKey);
        return (React.createElement("div", { className: className('card-follow message-card', { 'with-btn': onClick }) },
            React.createElement("div", { className: "card-header" }, titleStr),
            React.createElement("div", { className: "card-content" },
                React.createElement(BackgroundImage, { src: iconUrl, className: "lzd-follow-img" }),
                React.createElement("div", { className: "lzd-follow-desc" },
                    React.createElement("div", { className: "lzd-follow-desc-text" }, desc),
                    React.createElement(When, { condition: !!mallIconUrl },
                        React.createElement(BackgroundImage, { src: mallIconUrl, className: "lzd-mall-icon" })))),
            React.createElement(When, { condition: !!onClick },
                React.createElement("div", { className: "card-footer right" }, onClick && React.createElement("div", { className: "btn", onClick: function () { return onClick(templateData); } }, locale.follow || 'Follow')))));
    };
    return FollowCard;
}(React.Component));
export default FollowCard;

//# sourceMappingURL=index.js.map
